import "./App.css";
import { Preloader, Nav } from "./components/Chrome";
import { Hero, Ticker } from "./components/Hero";
import { Partners, Stats } from "./components/Proof";
import { Editorial, Services } from "./components/Growth";
import { Energy } from "./components/Energy";
import { CaseStudies } from "./components/CaseStudies";
import { Calculator } from "./components/Calculator";
import { QualifyWizard } from "./components/QualifyWizard";
import { Careers } from "./components/Careers";
import { FAQ, CTA, Footer } from "./components/Final";

function App() {
  return (
    <>
      <Preloader />
      <Nav />
      <Hero />
      <Ticker />
      <Partners />
      <Stats />
      <Editorial />
      <Services />
      <Energy />
      <CaseStudies />
      <Calculator />
      <QualifyWizard />
      <Careers />
      <FAQ />
      <CTA />
      <Footer />
    </>
  );
}

export default App;
